import { get, post } from '@/plugins/http'

export default {
  // 获取当前直播频道列表
  getAllChannels: post('/live/api/v1/channels/list'),
  // TODO: 获取推流拉流地址（待替换）
  getChannelAddress: get('/live/api/v1/channels/address'),
  // 获取课程频道状态（status: 0：空闲； 1：直播； 2：禁用； 3：直播录制）
  getChannelStatus: get('/live/api/v1/channels/stats'),
  // 设置/更新观看记录
  setViewHistory: post('/live/api/v1/attendees'),
  // TODO: 获取云信推流地址（待替换）
  getChannelAddressTranscode: get('/live/api/v1/channels/address/transcode'),
  // 获取频道地址转码，包含了两条线路
  getTranscode: get('/live/api/v1/channels/mix/address/transcode'),
}
